import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAmericanFootball: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconAmericanFootball"><Path d="M13 3L21 11M3 13L11 21M10 14L14 10M14.75 2.75H19.25C20.3546 2.75 21.25 3.64543 21.25 4.75V9.25C21.25 15.8774 15.8774 21.25 9.25 21.25H4.75C3.64543 21.25 2.75 20.3546 2.75 19.25V14.75C2.75 8.12258 8.12258 2.75 14.75 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconAmericanFootball;
